// CRM Access: true when the user may use a module/action (SA always can).
export const can = (u, key) => u?.role === "super_admin" || !!u?.permissions?.[key];
